<ng-template #cardTemplate>
    <eas-booking-item-option-slot
        *ngFor="let option of items | async"
        [bookingItemOption]="option.orig"></eas-booking-item-option-slot>
</ng-template>

<ng-container *ngIf="items">
    <app-list title="Available bookings" i18n-title
              [subtitle]="subtitle"
              [cardTemplate]="cardTemplate"
              [actions]="path.length > 0 ? actions : []"
    >
    </app-list>
</ng-container>
